export const confirmModule = {
    namespaced: true,

    state: {
        value: false,
        callback: null,
        cancelCallback: null,
        args: null,
        btnText: null,
        cancelBtnText: null,
        title: null,
        description: null
    },

    getters: {
        values: state => {
            return {
                value: state.value,
                callback: state.callback,
                cancelCallback: state.cancelCallback,
                args: state.args,
                description: state.description,
                title: state.title,
                btnText: state.btnText,
                cancelBtnText: state.cancelBtnText,
            }
        }
    },

    mutations: {
        view(state, data){
            state.value = true;
            if (typeof data === "function"){
                state.callback = data;
            }else{
                state.callback = data.callback || null;
                state.cancelCallback = data.cancelCallback || null;
                state.args = data.args || null;
                state.btnText = data.btnText || null;
                state.cancelBtnText = data.cancelBtnText || null;
                state.title = data.title || null;
                state.description = data.description || null;
            }
        },
        clear(state) {
            state.value = false;
            state.callback = null;
            state.cancelCallback = null;
            state.args = null;
            state.title = null;
            state.description = null;
            state.btnText = null;
            state.cancelBtnText = null;
        },
    },

    actions: {
        confirm({commit, state }) {
            if (typeof state.callback === "function"){
                state.callback(state.args)
            }
            commit('clear');
        },
        cancel({commit, state }){
            if (typeof state.cancelCallback === "function"){
                state.cancelCallback()
            }
            commit('clear');
        }
    }
}
